import { overviewFeatures } from "@/mocks/home";

export default function Overview() {
  return (
    <section id="overview" className="w-full bg-background-50 py-14 md:py-20">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <div className="max-w-2xl">
          <span className="text-xs md:text-sm font-label tracking-widest text-primary-600 uppercase">
            What You Can Find Here
          </span>
          <h2 className="mt-3 font-heading text-2xl md:text-4xl text-foreground-950">
            这个页面能帮你解决什么
          </h2>
          <p className="mt-4 text-sm md:text-base leading-relaxed text-foreground-600">
            与其在各个群聊、转载页和收藏夹之间来回切换，不如先弄清楚整体思路。
            下面四件事覆盖了「找不到入口」「即使用了入口也打不开」「担心进错站」这几类最常见的诉求。
          </p>
        </div>

        <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {overviewFeatures.map((item, index) => (
            <article
              key={item.title}
              className="p-5 rounded-lg bg-background-100 border border-background-200/70 flex flex-col"
            >
              <div className="flex items-center justify-between">
                <div className="w-11 h-11 rounded-md bg-primary-100 text-primary-700 flex items-center justify-center">
                  <i className={`${item.icon} text-xl`} aria-hidden="true"></i>
                </div>
                <span className="font-heading text-2xl text-background-300">
                  0{index + 1}
                </span>
              </div>
              <h3 className="mt-4 font-heading text-base md:text-lg text-foreground-950">
                {item.title}
              </h3>
              <p className="mt-2 text-xs md:text-sm leading-relaxed text-foreground-600">
                {item.desc}
              </p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}